// extracted by mini-css-extract-plugin
export default {"container":"Eo-z","brandName":"Fo-z","productName":"Go-z","productNamePdpEnhancements":"Ho-z","breakLongProductName":"Io-z"};